// register.js — entry del bundle fatt-v1: modulo Fatturazione (v2 NATIVO,
// flag-gated shell_fatt_v1). Tutta la logica di guardia vive in install.js
// (puro, testabile sotto node); qui SOLO il side-effect browser + l'aggancio
// della factory React.
//
// Guardia __shellFattV1Installed: se il file finisse iniettato due volte
// (manifest + fallback) niente doppia install — si marca SOLO a install
// riuscita (stesso pattern di sop-v3/register.js).

import { installFattV1 } from './install.js';
import { createFattV1 } from './FattApp.jsx';

if (typeof window !== 'undefined' && !window.__shellFattV1Installed) {
  if (installFattV1(window, createFattV1)) window.__shellFattV1Installed = true;
}
